var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              _c(
                "div",
                { staticClass: "table-page-search-wrapper" },
                [
                  _c(
                    "a-form",
                    { attrs: { layout: "inline" } },
                    [
                      _c(
                        "a-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 8, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "所属门店",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c(
                                    "a-select",
                                    {
                                      attrs: { placeholder: "请选择门店" },
                                      on: { change: _vm.onStoreChange },
                                      model: {
                                        value: _vm.storeId,
                                        callback: function ($$v) {
                                          _vm.storeId = $$v
                                        },
                                        expression: "storeId",
                                      },
                                    },
                                    _vm._l(_vm.storeOptionList, function (s) {
                                      return _c(
                                        "a-select-option",
                                        { key: s.id, attrs: { value: s.id } },
                                        [_vm._v(_vm._s(s.name))]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-tabs",
                {
                  model: {
                    value: _vm.activeTab,
                    callback: function ($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab",
                  },
                },
                [
                  _c(
                    "a-tab-pane",
                    { key: "instore", attrs: { tab: "堂食设置" } },
                    [
                      _c(
                        "a-form",
                        { staticClass: "setting-form" },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "营业时间",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                                required: "",
                              },
                            },
                            [
                              _c(
                                "a-radio-group",
                                {
                                  model: {
                                    value: _vm.form.timeType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "timeType", $$v)
                                    },
                                    expression: "form.timeType",
                                  },
                                },
                                [
                                  _c("a-radio", { attrs: { value: "1" } }, [
                                    _vm._v("全天24小时营业"),
                                  ]),
                                  _c("a-radio", { attrs: { value: "2" } }, [
                                    _vm._v("设置营业时间"),
                                  ]),
                                ],
                                1
                              ),
                              _vm.form.timeType === "2"
                                ? _c(
                                    "div",
                                    { staticClass: "time-rows" },
                                    [
                                      _vm._l(
                                        _vm.timeArr,
                                        function (item, index) {
                                          return _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass: "time-row",
                                            },
                                            [
                                              _c("a-time-picker", {
                                                staticStyle: { width: "150px" },
                                                attrs: {
                                                  value: _vm.toMoment(
                                                    item.startTime
                                                  ),
                                                  format: "HH:mm",
                                                  "minute-step": 5,
                                                  "allow-clear": false,
                                                  placeholder: "选择时间",
                                                },
                                                on: {
                                                  change: (t, val) =>
                                                    _vm.onTimeChange(
                                                      item,
                                                      "startTime",
                                                      val
                                                    ),
                                                },
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "time-sep" },
                                                [_vm._v("-")]
                                              ),
                                              item.ciri
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass: "time-ciri",
                                                    },
                                                    [_vm._v("次日")]
                                                  )
                                                : _vm._e(),
                                              _c("a-time-picker", {
                                                staticStyle: { width: "150px" },
                                                attrs: {
                                                  value: _vm.toMoment(
                                                    item.endTime
                                                  ),
                                                  format: "HH:mm",
                                                  "minute-step": 5,
                                                  "allow-clear": false,
                                                  placeholder: "选择时间",
                                                },
                                                on: {
                                                  change: (t, val) =>
                                                    _vm.onTimeChange(
                                                      item,
                                                      "endTime",
                                                      val
                                                    ),
                                                },
                                              }),
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "time-del",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.delTimeInterval(
                                                        index
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("删除")]
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      _c(
                                        "a-button",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.timeArr.length < 3,
                                              expression: "timeArr.length < 3",
                                            },
                                          ],
                                          attrs: { type: "link", icon: "plus" },
                                          on: { click: _vm.addTimeInterval },
                                        },
                                        [_vm._v("添加营业时间")]
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "商家公告",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                              },
                            },
                            [
                              _c("a-textarea", {
                                attrs: {
                                  placeholder: "请输入商家公告",
                                  rows: 3,
                                },
                                model: {
                                  value: _vm.form.notice,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "notice", $$v)
                                  },
                                  expression: "form.notice",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "下单公告",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                              },
                            },
                            [
                              _c("a-textarea", {
                                attrs: {
                                  placeholder: "请输入下单公告",
                                  rows: 3,
                                },
                                model: {
                                  value: _vm.form.orderNotice,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "orderNotice", $$v)
                                  },
                                  expression: "form.orderNotice",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "下单幻灯片",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                              },
                            },
                            [
                              _c("j-image-upload", {
                                attrs: {
                                  bizPath: "material",
                                  text: "上传幻灯片",
                                  isMultiple: "",
                                },
                                model: {
                                  value: _vm.form.orderMedia,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "orderMedia", $$v)
                                  },
                                  expression: "form.orderMedia",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "自动接单",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                              },
                            },
                            [
                              _c(
                                "a-radio-group",
                                {
                                  model: {
                                    value: _vm.form.receiving,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "receiving", $$v)
                                    },
                                    expression: "form.receiving",
                                  },
                                },
                                [
                                  _c("a-radio", { attrs: { value: "1" } }, [
                                    _vm._v("开启"),
                                  ]),
                                  _c("a-radio", { attrs: { value: "2" } }, [
                                    _vm._v("关闭"),
                                  ]),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "field-tip" }, [
                                _vm._v("商家接单后才打印小票,为防漏单建议开启"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "结算模式",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                              },
                            },
                            [
                              _c(
                                "a-radio-group",
                                {
                                  model: {
                                    value: _vm.form.payMode,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "payMode", $$v)
                                    },
                                    expression: "form.payMode",
                                  },
                                },
                                [
                                  _c("a-radio", { attrs: { value: "1" } }, [
                                    _vm._v("先结账后用餐"),
                                  ]),
                                  _c("a-radio", { attrs: { value: "2" } }, [
                                    _vm._v("先用餐后结账"),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.form.payMode === "1",
                                      expression: "form.payMode === '1'",
                                    },
                                  ],
                                  staticClass: "field-tip",
                                },
                                [
                                  _vm._v(
                                    "顾客点餐付钱后,商家即可收到订单准备上菜"
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.form.payMode === "2",
                                      expression: "form.payMode === '2'",
                                    },
                                  ],
                                  staticClass: "field-tip",
                                },
                                [
                                  _vm._v(
                                    "顾客点餐下单给商家,商家开始准备上菜,顾客可以吃完后付钱,未支付顾客可以加菜"
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.form.payMode === "2",
                                  expression: "form.payMode === '2'",
                                },
                              ],
                              attrs: {
                                label: "线上支付",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                              },
                            },
                            [
                              _c(
                                "a-radio-group",
                                {
                                  model: {
                                    value: _vm.form.onLine,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "onLine", $$v)
                                    },
                                    expression: "form.onLine",
                                  },
                                },
                                [
                                  _c("a-radio", { attrs: { value: "1" } }, [
                                    _vm._v("开启"),
                                  ]),
                                  _c("a-radio", { attrs: { value: "2" } }, [
                                    _vm._v("关闭"),
                                  ]),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "field-tip" }, [
                                _vm._v(
                                  "关闭后用户端将不显示支付按钮，仅能线下结账"
                                ),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.form.payMode === "1",
                                  expression: "form.payMode === '1'",
                                },
                              ],
                              attrs: {
                                label: "清台设置",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                              },
                            },
                            [
                              _c(
                                "a-radio-group",
                                {
                                  model: {
                                    value: _vm.form.autoClose,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "autoClose", $$v)
                                    },
                                    expression: "form.autoClose",
                                  },
                                },
                                [
                                  _c("a-radio", { attrs: { value: "1" } }, [
                                    _vm._v("开启"),
                                  ]),
                                  _c("a-radio", { attrs: { value: "2" } }, [
                                    _vm._v("关闭"),
                                  ]),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "field-tip" }, [
                                _vm._v(
                                  "开启后，未支付订单将在设置的清台时间后自动关单并释放桌台，此功能仅在先结账后用餐模式下生效"
                                ),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.form.payMode === "1" &&
                                    _vm.form.autoClose === "1",
                                  expression:
                                    "form.payMode === '1' && form.autoClose === '1'",
                                },
                              ],
                              attrs: {
                                label: "清台时间",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                              },
                            },
                            [
                              _c("a-input-number", {
                                staticStyle: { width: "200px" },
                                attrs: {
                                  min: 1,
                                  precision: 0,
                                  placeholder: "请输入清台时间",
                                },
                                model: {
                                  value: _vm.form.closeTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "closeTime", $$v)
                                  },
                                  expression: "form.closeTime",
                                },
                              }),
                              _c("span", { staticClass: "unit-text" }, [
                                _vm._v("分钟后自动清台"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "点餐模式",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                              },
                            },
                            [
                              _c(
                                "a-radio-group",
                                {
                                  model: {
                                    value: _vm.form.orderMode,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "orderMode", $$v)
                                    },
                                    expression: "form.orderMode",
                                  },
                                },
                                [
                                  _c("a-radio", { attrs: { value: "1" } }, [
                                    _vm._v("多人点餐"),
                                  ]),
                                  _c("a-radio", { attrs: { value: "2" } }, [
                                    _vm._v("拼桌点餐"),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.form.orderMode === "1",
                                      expression: "form.orderMode === '1'",
                                    },
                                  ],
                                  staticClass: "field-tip",
                                },
                                [_vm._v("同桌共享购物车，互相可见")]
                              ),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.form.orderMode === "2",
                                      expression: "form.orderMode === '2'",
                                    },
                                  ],
                                  staticClass: "field-tip",
                                },
                                [_vm._v("多人共用一桌，各自独立点餐下单")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "服务费",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                              },
                            },
                            [
                              _c(
                                "a-radio-group",
                                {
                                  model: {
                                    value: _vm.form.serviceType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "serviceType", $$v)
                                    },
                                    expression: "form.serviceType",
                                  },
                                },
                                [
                                  _c("a-radio", { attrs: { value: "1" } }, [
                                    _vm._v("按就餐人数收取"),
                                  ]),
                                  _c("a-radio", { attrs: { value: "2" } }, [
                                    _vm._v("按每桌台收取"),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "service-fee" },
                                [
                                  _c("a-input-number", {
                                    staticStyle: { width: "200px" },
                                    attrs: {
                                      min: 0,
                                      precision: 2,
                                      placeholder: "请输入服务费金额",
                                    },
                                    model: {
                                      value: _vm.form.serviceMoney,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "serviceMoney", $$v)
                                      },
                                      expression: "form.serviceMoney",
                                    },
                                  }),
                                  _c("span", { staticClass: "unit-text" }, [
                                    _vm._v(
                                      "元/" +
                                        _vm._s(
                                          _vm.form.serviceType === "1"
                                            ? "位"
                                            : "桌"
                                        )
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "选择人数开关",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                              },
                            },
                            [
                              _c(
                                "a-radio-group",
                                {
                                  model: {
                                    value: _vm.form.select_numbe_switch,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "select_numbe_switch",
                                        $$v
                                      )
                                    },
                                    expression: "form.select_numbe_switch",
                                  },
                                },
                                [
                                  _c("a-radio", { attrs: { value: "1" } }, [
                                    _vm._v("开启"),
                                  ]),
                                  _c("a-radio", { attrs: { value: "2" } }, [
                                    _vm._v("关闭"),
                                  ]),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "field-tip" }, [
                                _vm._v("开启后,桌码扫码提示选择就餐人数"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "form-footer" },
                        [
                          _c(
                            "a-button",
                            {
                              attrs: { type: "primary", loading: _vm.saving },
                              on: {
                                click: function ($event) {
                                  return _vm.handleSave("instore")
                                },
                              },
                            },
                            [_vm._v("保存")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-tab-pane",
                    { key: "fast", attrs: { tab: "快餐设置" } },
                    [
                      _c(
                        "a-form",
                        { staticClass: "setting-form" },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "自动接单",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                              },
                            },
                            [
                              _c(
                                "a-radio-group",
                                {
                                  model: {
                                    value: _vm.form2.receiving,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form2, "receiving", $$v)
                                    },
                                    expression: "form2.receiving",
                                  },
                                },
                                [
                                  _c("a-radio", { attrs: { value: "1" } }, [
                                    _vm._v("开启"),
                                  ]),
                                  _c("a-radio", { attrs: { value: "2" } }, [
                                    _vm._v("关闭"),
                                  ]),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "field-tip" }, [
                                _vm._v("此功能关闭后,商家需要手动接单"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "快餐公告",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                              },
                            },
                            [
                              _c("a-textarea", {
                                attrs: {
                                  placeholder: "请输入快餐公告",
                                  rows: 3,
                                },
                                model: {
                                  value: _vm.form2.notice,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form2, "notice", $$v)
                                  },
                                  expression: "form2.notice",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "下单公告",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                              },
                            },
                            [
                              _c("a-textarea", {
                                attrs: {
                                  placeholder: "请输入下单公告",
                                  rows: 3,
                                },
                                model: {
                                  value: _vm.form2.orderNotice,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form2, "orderNotice", $$v)
                                  },
                                  expression: "form2.orderNotice",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "下单幻灯片",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                              },
                            },
                            [
                              _c("j-image-upload", {
                                attrs: {
                                  bizPath: "material",
                                  text: "上传幻灯片",
                                  isMultiple: "",
                                },
                                model: {
                                  value: _vm.form2.orderMedia,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form2, "orderMedia", $$v)
                                  },
                                  expression: "form2.orderMedia",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "打包盒收费模式",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                              },
                            },
                            [
                              _c(
                                "a-radio-group",
                                {
                                  model: {
                                    value: _vm.form2.boxType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form2, "boxType", $$v)
                                    },
                                    expression: "form2.boxType",
                                  },
                                },
                                [
                                  _c("a-radio", { attrs: { value: "1" } }, [
                                    _vm._v("按订单收费"),
                                  ]),
                                  _c("a-radio", { attrs: { value: "2" } }, [
                                    _vm._v("按商品收费"),
                                  ]),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "field-tip" }, [
                                _vm._v(
                                  "假设打包盒2元,按订单收费是指该订单收取2元打包费"
                                ),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.form2.boxType === "1",
                                  expression: "form2.boxType === '1'",
                                },
                              ],
                              attrs: {
                                label: "打包盒费",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                              },
                            },
                            [
                              _c("a-input-number", {
                                staticStyle: { width: "200px" },
                                attrs: {
                                  min: 0,
                                  max: 100000000,
                                  precision: 2,
                                  placeholder: "请输入打包盒费",
                                },
                                model: {
                                  value: _vm.form2.boxMoney,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form2, "boxMoney", $$v)
                                  },
                                  expression: "form2.boxMoney",
                                },
                              }),
                              _c("span", { staticClass: "unit-text" }, [
                                _vm._v("元"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "取餐语音文字",
                                labelCol: _vm.formLabelCol,
                                wrapperCol: _vm.formWrapperCol,
                              },
                            },
                            [
                              _c("a-input", {
                                staticStyle: { width: "260px" },
                                attrs: {
                                  placeholder: "请",
                                  addonAfter: "A001",
                                },
                                model: {
                                  value: _vm.form2.phoneticWritingStart,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form2,
                                      "phoneticWritingStart",
                                      $$v
                                    )
                                  },
                                  expression: "form2.phoneticWritingStart",
                                },
                              }),
                              _c("a-input", {
                                staticStyle: {
                                  width: "240px",
                                  "margin-left": "10px",
                                },
                                attrs: { placeholder: "号到服务台取餐" },
                                model: {
                                  value: _vm.form2.phoneticWritingEnd,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form2,
                                      "phoneticWritingEnd",
                                      $$v
                                    )
                                  },
                                  expression: "form2.phoneticWritingEnd",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "form-footer" },
                        [
                          _c(
                            "a-button",
                            {
                              attrs: { type: "primary", loading: _vm.saving },
                              on: {
                                click: function ($event) {
                                  return _vm.handleSave("fast")
                                },
                              },
                            },
                            [_vm._v("保存")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }